import { getVendor, createVendor } from '../services/vendorServices';

const initialState = {
  fetchingLoading: true,
  //vendorlist
  arrVendor: [],
  error: false,
  createLoading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'fetching_vendor':
      return {
        ...state,
        fetchingLoading: true,
        error: false
      };
    case 'fetching_vendor_success':
      return {
        ...state,
        arrVendor: action.data,
        fetchingLoading: false,
        error: false
      };
    case 'creating_vendor':
      return {
        ...state,
        createLoading: true,
        error: false
      };
    case 'creating_vendor_success':
      return {
        ...state,
        arrVendor: [...state.arrVendor, action.data],
        createLoading: false,
        error: false
      };
    case 'fetching_error':
      return {
        ...state,
        message: action.message,
        error: true,
        loading: false
      };
    default:
      return state;
  }
};

export const fetchVendorAction = () => {
  return async (dispatch) => {
    dispatch({ type: 'fetching_vendor' });
    //TODO get companyId (set temp companyId = '0')
    try {
      const data = await getVendor('0');
      dispatch({
        type: 'fetching_vendor_success',
        data: data.data
      });
    } catch (error) {
      dispatch({
        type: 'fetching_error',
        message: 'Fetching error'
      });
    }
  };
};

export const createVendorAction = (body) => {
  return async (dispatch) => {
    dispatch({ type: 'creating_vendor' });
    try {
      //TODO add companyId to body
      const data = await createVendor({ ...body, companyId: '0' });
      dispatch({
        type: 'creating_vendor_success',
        data: data.data
      });
    } catch (error) {
      dispatch({
        type: 'fetching_error',
        message: 'Fetching error'
      });
    }
  };
};
